(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.language-selector-custom').forEach((wrapper) => {
    const toggle = wrapper.querySelector('.language-selector-custom__toggle');
    const list = wrapper.querySelector('.language-selector-custom__list');
    const input = wrapper.parentElement.querySelector('input[name="language_code"]');
    const form = wrapper.closest('form');

    if (!toggle || !list || !input || !form) return;

    const closeList = () => {
      list.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    };

    const openList = () => {
      list.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    };

    toggle.addEventListener('click', () => {
      list.hidden ? openList() : closeList();
    });

    list.querySelectorAll('.language-selector-custom__option').forEach((option) => {
      option.addEventListener('click', () => {
        const locale = option.dataset.localeCode;
        if (locale === input.value) {
          closeList();
          return;
        }
        input.value = locale;
        form.requestSubmit();
      });
    });

    document.addEventListener('click', (event) => {
      if (!wrapper.contains(event.target)) closeList();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeList();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
